import { Flex, Heading } from "@chakra-ui/react";
import { GameCard, NextPageButton } from "../../components";
import practiceGames from "../../practiceGames";

const PracticeGameSelect = () => {
  return (
    <Flex
      flex="1"
      direction="column"
      align="center"
      gap="30px"
      p={{ base: 4, md: 8 }}
    >
      <Heading as="h2" size="lg" color="headline.400" fontStyle="italic">
        Practice Games
      </Heading>
      <Flex gap={6} flexWrap="wrap" justify="center">
        {practiceGames.map((game) => (
          <GameCard
            key={game.id}
            title={game.title}
            description={game.description}
            path={game.path}
          />
        ))}
      </Flex>
      <NextPageButton to="/play" label="Play" />
    </Flex>
  );
};
export default PracticeGameSelect;
